import { z, ZodType } from "zod";
import api from "@/lib/axiosConfig";
import { baseRoute } from "./exhibition";

export const exhibitionSchema = z.object({
  id: z.string().optional(),
  expositionsDescriptionNumeroExpo: z
    .string()
    .nonempty("form.error.emptyField"),
  expositionsDescriptionTitre: z.string(),
});

export const appendNoDuplicateExhibitionNumberRefine = <
  T extends {
    id?: string;
    expositionsDescriptionNumeroExpo: string;
  },
>(
  schema: ZodType<T>,
) =>
  schema.refine(
    async (val) =>
      await validateNoDuplicateRecordNumbers(
        val.expositionsDescriptionNumeroExpo,
        val.id,
      )
        .then(() => true)
        .catch(() => false),
    {
      message: "form.error.exhibition.duplicateExhibitionNumbers",
      path: ["expositionsDescriptionNumeroExpo"],
    },
  );

export async function validateNoDuplicateRecordNumbers(
  exhibitionNumber: string,
  id?: string,
) {
  await api.get<void>(`${baseRoute}/exhibition-number/validate/no-duplicates`, {
    params: {
      value: exhibitionNumber,
      id,
    },
  });
}
